import {
  Box,
  Button,
  Heading,
  Image,
  Text,
  useMediaQuery
} from '@chakra-ui/react'
import { Link } from 'react-router-dom'

import SessionStartLogo from '../../components/SessionStartLogo'
const quilmesImages = require.context('../../assets/images', true)

const ConfirmSucces = () => {
  const [isLargerThan768] = useMediaQuery('(min-width: 780px)')

  return (
    <Box display={{ md: 'flex' }} justifyContent={'center'}>
      <Box mx={'auto'}>
        <Box
          alignItems={'flex-start'}
          autoComplete='off'
          padding={{ base: '2rem 1rem 2rem 1rem', md: '4rem 1rem 2rem 1rem' }}
          w={{ base: '100%', md: 500 }}
        >
          <SessionStartLogo />
          <Box paddingTop={{ base: '2rem', md: '4rem' }}>
            <Heading fontSize={'24px'} fontWeight={'400'} width={{ base: '100%', md: '80%' }}
            >
              ¡Listo! Tu correo electrónico fue verificado
            </Heading>
            <Text fontSize={'14px'} paddingTop={{ base: '1rem', md: '0.5rem' }}>
              Ya podés ingresar a la plataforma.
            </Text>
            <Link to={'/'}>
              <Button
                _focusVisible={{ outline: 'none' }}
                marginTop={'3rem'}
                variant={'btn-quilmes'}
                width={{ base: '100%', md: '80%' }}
              >
                Iniciar Sesión
              </Button>
            </Link>
          </Box>
        </Box>
      </Box>
      <Box
        alignItems={'center'}
        bgColor={'#F7F7F7'}
        justifyContent={'center'}
        w={'50%'}
        {...(isLargerThan768
          ? { margin: '0', height: '100vh' }
          : { margin: '0 auto', height: 'auto' })}
      >
        {isLargerThan768
          ? (
            <Image
              alt='logo'
              h={'auto'}
              margin={0}
              mx={'auto'}
              objectFit='cover'
              padding={0}
              paddingTop={'2.5rem'}
              src={quilmesImages('./ilustracion.svg')}
              w={{ md: '50%' }}
            />
          )
          : null}
      </Box>
    </Box>
  )
}

export default ConfirmSucces
